export const PAYMENT_TRANSACTION_STATUS_SYNC_REQUESTED = "sync-requested"


// WEBPACK FOOTER //
// ./src/state/payment/PaymentTransactionStatus.ts